import type { TConfig } from './models';

export const WHITE = 'white';
export const BLUE = 'blue';

export const DEFAULT_THEME = WHITE;

export const THEMES = [WHITE, BLUE];

export const CONFIG: TConfig = {
    link: {
        view: 'primary-medium',
    },
    size: {
        view: 'secondary-medium',
    },
};
